import React from "react";
import PageTemplate from "../components/PageTemplate";

export default function Judges() {
  return (
    <PageTemplate>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-8 sm:py-12 lg:py-16 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in drop-shadow-lg">
            Judges
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full shadow-lg"></div>
        </div>
      </div>

      {/* Stay Tuned Section */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main content card */}
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 sm:p-12 lg:p-16 border-2 border-peach-200 shadow-2xl animate-fade-in">
            {/* Large emoji */}
            <div className="text-8xl sm:text-9xl mb-6 sm:mb-8 animate-bounce" style={{ animationDuration: '3s' }}>
              🎭
            </div>
            
            {/* Main message */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-text font-bold text-coral mb-6 sm:mb-8 animate-slide-up">
              Stay Tuned!
            </h2>
            
            <p className="text-lg sm:text-xl md:text-2xl text-teal-600 font-text mb-8 sm:mb-10 leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
              We're working hard to bring you an incredible lineup of judges for this year's competition.
            </p>
            
            {/* Additional info */}
            <div className="bg-gradient-to-r from-coral-100 to-sky-100 rounded-2xl p-6 sm:p-8 mb-6 sm:mb-8 animate-slide-up" style={{ animationDelay: '0.4s' }}>
              <p className="text-base sm:text-lg text-coral-600 font-text font-semibold mb-2">
                🎪 Coming Soon
              </p>
              <p className="text-sm sm:text-base text-teal-600 font-text">
                Follow us on social media and check back regularly for updates on our judging panel!
              </p>
            </div>
            
            {/* Call to action */}
            <div className="animate-slide-up" style={{ animationDelay: '0.6s' }}>
              <p className="text-base sm:text-lg text-teal-600 font-text mb-4">
                In the meantime, explore our other pages to learn more about the competition!
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a 
                  href="/teams" 
                  className="inline-block bg-teal text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-button font-semibold hover:bg-teal-400 transform hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  View Teams
                </a>
                <a 
                  href="/schedule" 
                  className="inline-block bg-coral text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-button font-semibold hover:bg-coral-400 transform hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  Event Schedule
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
}